import $ from 'jquery'

/**
 * Adapter for Bootstrap's popover plugin.
 * @param {HTMLElement} element - The element to which the adapter is applied.
 * @param {Object} options - Options for the popover plugin.
 * @returns {void}
 */
export default (element, options) => {
  $(element).popover(options)
}
